// C1 - Ünite 3: Advanced Modal Verbs
// Hedef: Must have, Should have, Could have (geçmiş çıkarım/pişmanlık)

export const C1_UNIT_3 = {
  'C1-U3-L1': {
    id: 'C1-U3-L1',
    title: 'Must have / Can\'t have (çıkarım)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Geçmişe Dair Çıkarım',
          explanation: 'Geçmişte ne olduğuna dair kesin veya güçlü tahminler yapmak için kullanılır.',
          table: {
            headers: ['Yapı', 'Örnek', 'Anlam'],
            rows: [
              ['Must have + V3', 'She must have missed the flight.', 'Uçuşu kaçırmış olmalı (eminim)'],
              ['Can\'t have + V3', 'He can\'t have forgotten.', 'Unutmuş olamaz (imkansız)'],
              ['Couldn\'t have + V3', 'They couldn\'t have known.', 'Bilmiş olamazlar'],
              ['Must not have + V3', 'She must not have heard the announcement.', 'Anonsu duymamış olmalı']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Must have = %95 eminim oldu | Can\'t have = İmkansız, olmadı'
        },
        {
          type: 'vocabulary',
          title: '✈️ Kabin Örnekleri',
          words: [
            { en: 'The passenger must have left it in the overhead bin.', tr: 'Yolcu bunu üst dolapta bırakmış olmalı.' },
            { en: 'She can\'t have boarded without a ticket.', tr: 'Biletsiz binmiş olamaz.' },
            { en: 'They must have been very tired after 15 hours.', tr: '15 saat sonra çok yorgun olmuş olmalılar.' }
          ]
        }
      ],
      exercises: [
        {
          type: 'swipeVocabulary',
          title: '🎴 Modal Verbs - Çıkarım',
          cards: [
            { front: 'must have been', back: '... olmuş olmalı', example: 'It must have been difficult.' },
            { front: 'can\'t have done', back: 'yapmış olamaz', example: 'She can\'t have done that.' },
            { front: 'must have forgotten', back: 'unutmuş olmalı', example: 'He must have forgotten.' },
            { front: 'couldn\'t have known', back: 'bilmiş olamaz', example: 'We couldn\'t have known.' },
            { front: 'must have left', back: 'bırakmış olmalı', example: 'I must have left it at home.' },
            { front: 'can\'t have seen', back: 'görmüş olamaz', example: 'He can\'t have seen us.' }
          ]
        },
        {
          type: 'multipleChoice',
          question: 'The passenger is not in his seat. He ___ to the restroom.',
          options: ['must go', 'must have gone', 'can go', 'should go'],
          correctIndex: 1,
          explanation: 'Geçmişe dair güçlü çıkarım için "must have gone" kullanılır.'
        }
      ]
    }
  },

  'C1-U3-L2': {
    id: 'C1-U3-L2',
    title: 'Should have / Shouldn\'t have (pişmanlık)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Geçmişe Dair Pişmanlık/Eleştiri',
          explanation: 'Geçmişte yapılması gereken ama yapılmayan (veya yapılmaması gereken ama yapılan) eylemler için.',
          table: {
            headers: ['Yapı', 'Örnek', 'Anlam'],
            rows: [
              ['Should have + V3', 'I should have checked twice.', 'Kontrol etmeliydim (ama etmedim)'],
              ['Shouldn\'t have + V3', 'You shouldn\'t have said that.', 'Bunu söylememeliydin (ama söyledin)'],
              ['Ought to have + V3', 'We ought to have arrived earlier.', 'Daha erken varmalıydık']
            ]
          }
        },
        {
          type: 'example',
          title: '✈️ Kabin Memuru Pişmanlıkları',
          items: [
            { en: 'I should have offered water earlier.', tr: 'Daha önce su ikram etmeliydim.' },
            { en: 'We shouldn\'t have ignored the passenger\'s request.', tr: 'Yolcunun isteğini görmezden gelmemeliydin.' },
            { en: 'The captain should have made the announcement sooner.', tr: 'Kaptan anonsu daha erken yapmalıydı.' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'The flight was delayed. We ___ the passengers immediately.',
          options: ['should inform', 'should have informed', 'must inform', 'can inform'],
          correctIndex: 1,
          explanation: 'Geçmişte yapılması gereken ama yapılmayan için "should have informed" kullanılır.'
        },
        {
          type: 'fillBlank',
          sentences: [
            { text: 'I ___ ___ ___ (should/bring) extra supplies.', answer: 'should have brought' },
            { text: 'We ___ ___ ___ (not/should/wait) so long.', answer: 'shouldn\'t have waited' }
          ]
        }
      ]
    }
  },

  'C1-U3-L3': {
    id: 'C1-U3-L3',
    title: 'Could have / Might have (olasılık)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Geçmiş Olasılıklar',
          explanation: 'Geçmişte mümkün olan ama gerçekleşmemiş durumlar veya belirsiz tahminler için.',
          table: {
            headers: ['Yapı', 'Örnek', 'Anlam'],
            rows: [
              ['Could have + V3', 'I could have helped.', 'Yardım edebilirdim (ama etmedim)'],
              ['Might have + V3', 'She might have missed the bus.', 'Otobüsü kaçırmış olabilir (belki)'],
              ['May have + V3', 'They may have already left.', 'Belki çoktan gitmişlerdir'],
              ['Could not have + V3', 'I couldn\'t have done it alone.', 'Bunu tek başıma yapamazdım']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Could have = Yapabilirdim ama yapmadım | Might/May have = Belki olmuştur (belirsiz tahmin)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'The passenger looks relieved. She ___ good news.',
          options: ['might receive', 'might have received', 'must receive', 'should receive'],
          correctIndex: 1,
          explanation: 'Belirsiz geçmiş tahmini için "might have received" kullanılır.'
        }
      ]
    }
  },

  'C1-U3-L4': {
    id: 'C1-U3-L4',
    title: 'Would rather / Had better',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Would rather & Had better',
          explanation: 'Tercih ve tavsiye ifade eden yapılar.',
          table: {
            headers: ['Yapı', 'Örnek', 'Anlam'],
            rows: [
              ['Would rather + V1', 'I\'d rather sit by the window.', 'Pencere kenarında oturmayı tercih ederim'],
              ['Would rather + not + V1', 'I\'d rather not fly at night.', 'Gece uçmayı tercih etmem'],
              ['Had better + V1', 'You\'d better fasten your seatbelt.', 'Kemerinizi bağlasanız iyi olur'],
              ['Had better + not', 'We\'d better not be late.', 'Geç kalmasak iyi olur'],
              ['Would rather have + V3', 'I\'d rather have stayed home.', 'Evde kalmayı tercih ederdim (ama kalmadım)']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Would rather = Tercih | Had better = Güçlü tavsiye/uyarı (yapmazsan kötü olur)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'The weather is getting worse. We ___ land soon.',
          options: ['would rather', 'had better', 'would like', 'prefer to'],
          correctIndex: 1,
          explanation: 'Acil tavsiye/uyarı için "had better" kullanılır.'
        },
        {
          type: 'fillBlank',
          sentences: [
            { text: 'I\'d ___ have an aisle seat, please.', answer: 'rather' },
            { text: 'You\'d ___ not smoke here.', answer: 'better' }
          ]
        }
      ]
    }
  },

  'C1-U3-L5': {
    id: 'C1-U3-L5',
    title: 'Uygulama: Kriz Analizi',
    type: 'practice',
    content: {
      sections: [
        {
          type: 'scenario',
          title: '✈️ Olay İnceleme: Türbülans',
          dialogues: [
            {
              speaker: 'Baş Kabin Memuru',
              text: 'We should have secured the service carts earlier.',
              translation: 'Servis arabalarını daha önce sabitlemeliydik.'
            },
            {
              speaker: 'Kabin Memuru',
              text: 'The passenger must have been standing when it happened.',
              translation: 'Olduğunda yolcu ayakta durmuş olmalı.'
            },
            {
              speaker: 'Kaptan',
              text: 'We couldn\'t have predicted such sudden turbulence.',
              translation: 'Bu kadar ani türbülansı tahmin edemezdik.'
            },
            {
              speaker: 'Baş Kabin Memuru',
              text: 'We\'d better complete the incident report immediately.',
              translation: 'Olay raporunu hemen tamamlasak iyi olur.'
            }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'The service cart moved. We ___ it properly.',
          options: [
            'must secure',
            'should have secured',
            'might secure',
            'would secure'
          ],
          correctIndex: 1,
          explanation: 'Geçmişte yapılması gereken ama yapılmayan = should have secured'
        }
      ]
    }
  },

  'C1-U3-EXAM': {
    id: 'C1-U3-EXAM',
    title: '📝 Ünite 3 Sınavı',
    type: 'exam',
    content: {
      timeLimit: 20,
      passingScore: 80,
      questions: [
        {
          type: 'multipleChoice',
          question: 'The passenger isn\'t here. He ___ early.',
          options: ['must leave', 'must have left', 'should leave', 'can leave'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'I ___ the safety demo. It was a mistake.',
          options: ['should skip', 'shouldn\'t have skipped', 'must skip', 'might skip'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'With this weather, we ___ land soon.',
          options: ['would rather', 'had better', 'might have', 'could have'],
          correctIndex: 1
        }
      ]
    }
  }
};

export default C1_UNIT_3;
